import { combineReducers } from 'redux';
import * as constants from './actions';

const summary = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_HELP_SUMMARY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  summary
});

export const getHelpSummary = state => {
  return state.user.help.summary;
};
